/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_Seo_DescriptionInputs */

const en_marketing_contact_seo_description = /** @type {(inputs: Marketing_Contact_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions about Onyx, licensing, or having JXD build your product. One email reaches the engineer.`)
};

const es_marketing_contact_seo_description = /** @type {(inputs: Marketing_Contact_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas sobre Onyx, la licencia o encargar a JXD la creación de tu producto. Un solo correo llega al ingeniero.`)
};

const fr_marketing_contact_seo_description = /** @type {(inputs: Marketing_Contact_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions sur Onyx, la licence, ou confier la construction de votre produit à JXD. Un seul e-mail atteint l'ingénieur.`)
};

/**
* | output |
* | --- |
* | "Questions about Onyx, licensing, or having JXD build your product. One email reaches the engineer." |
*
* @param {Marketing_Contact_Seo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_seo_description = /** @type {((inputs?: Marketing_Contact_Seo_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_Seo_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_seo_description(inputs)
	if (locale === "es") return es_marketing_contact_seo_description(inputs)
	return fr_marketing_contact_seo_description(inputs)
});